import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { getResortUserColor } from 'src/lib/getResortUserColor';
import { Construction } from 'src/models/resort/Construction';
import { UserResortProfile } from 'src/models/resort/UserResortProfile';
import { ResortConstructionGridItems } from './ResortConstructionGridItems';
import { ResortPromotionUser } from './ResortPromotionUser';

interface ResortOtherPromotionContentProps {
  basePath: string;
  profile: UserResortProfile;
  isFollowing: boolean;
}

export const ResortOtherPromotionContent: React.FC<ResortOtherPromotionContentProps> = ({
  basePath,
  profile,
  isFollowing
}) => {
  const { t } = useTranslation('resort');
  const history = useHistory();

  const handleItemClick = useCallback(
    (construction: Construction) => {
      history.push(`${basePath}/constructions/${construction.resortId}`);
    },
    [basePath, history]
  );

  const userColor = getResortUserColor(profile.resortPlannerPromotionColor);

  return (
    <div
      className={css`
        width: 100%;
        max-width: 480px;
        margin: 0 auto;
        padding: 32px 16px;
        color: #4d3906;

        .grid-label {
          font-size: 14px;
          margin: 32px 0 8px;
        }
      `}
    >
      <ResortPromotionUser profile={profile} isFollowing={isFollowing} />
      <p className="grid-label">{t('resort_list')}</p>
      <ResortConstructionGridItems
        items={profile.constructions}
        userColor={userColor}
        onItemClick={handleItemClick}
      />
    </div>
  );
};
